<template>
    <div>
        <v-data-table
            :loading="loader"
            disable-initial-sort
            :rows-per-page-items="rowPerPage"
            :headers="headers"
            :items="items"
            item-key="id"
            :search="search"
        >
            <!-- <template #headers="props">
                <tr>
                    <th
                        :class="['fw-bold', `text-xs-${header.align}`]"
                        v-for="header in props.headers"
                        :key="header.text"
                    >{{ header.text }}</th>
                </tr>
            </template> -->
            <template #items="props">
                <tr>
                    <td class="text-center">{{ props.index + 1 }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">
                        <span
                            v-if="!props.item.loading"
                            :class="props.item.is_paid ? 'v-badge primary' : 'v-badge warning'"
                        >{{ props.item.is_paid ? 'Đã chi' : 'Chưa chi' }}</span>
                        <v-progress-circular
                            v-else
                            color="primary"
                            indeterminate
                            size="14"
                            class="ml-2"
                        ></v-progress-circular>
                    </td>
                    <td
                        class="text-center text-no-wrap"
                    >{{ props.item.date_deposit | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.amount | formatNumber }}</td>
                    <td
                        class="text-center text-no-wrap"
                    >{{ props.item.agent_id | translateAgentName }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.type | translateText }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                    <td class="text-center">{{ props.item.status_text }}</td>
                    <td style="min-width: 144px" class="text-center text-no-wrap">
                        <v-checkbox
                            :disabled="loader"
                            v-if="!props.item.loading"
                            :label="props.item.is_paid ? 'Đã chi' : 'Chưa chi'"
                            color="primary"
                            v-model="props.item.is_paid"
                            hide-details
                            @change="toggleCommissionStatus(props.item)"
                            class="justify-center"
                        ></v-checkbox>
                        <v-progress-circular
                            v-else
                            color="primary"
                            indeterminate
                            size="24"
                            class="ml-2"
                        ></v-progress-circular>
                    </td>
                </tr>
            </template>
            <template #no-data>Chưa có thông tin</template>
        </v-data-table>
        <print-portal layout="portrait" :open="print_dialog" @close="print_dialog = false">
            <print-tien-dan-phong
                :chosen_building="chosen_building"
                :items="items"
                :agent_id="agent_id"
            ></print-tien-dan-phong>
        </print-portal>
    </div>
</template>

<script>
import api from "../../api/index";
import { buildParamQuery } from "../../helpers/helpers";
import PrintPortal from "../../components/Print/PrintPortal";
import PrintTienDanPhong from "../../components/Print/PrintTienDanPhong";
export default {
    name: "table-dan-phong",
    components: {
        PrintPortal,
        PrintTienDanPhong
    },
    props: {
        search: String,
        date_start: String,
        date_end: String,
        chosen_building: String,
        print: Number,
        agent_id: Number
    },
    data() {
        return {
            headers: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Số phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "is_paid"
                },
                {
                    text: "Ngày dẫn",
                    align: "center",
                    sortable: true,
                    value: "date_deposit"
                },
                {
                    text: "Số tiền",
                    align: "center",
                    sortable: true,
                    value: "amount"
                },
                {
                    text: "Người dẫn",
                    align: "center",
                    sortable: true,
                    value: "agent_id"
                },
                {
                    text: "Ghi chú",
                    align: "center",
                    sortable: true,
                    value: "type"
                },
                {
                    text: "Mã phiếu cọc",
                    align: "center",
                    sortable: true,
                    value: "receipt_id"
                },
                {
                    text: "Nhận phòng",
                    align: "center",
                    sortable: true,
                    value: "receipt_status"
                },
                {
                    text: "Hành động",
                    align: "center",
                    sortable: true,
                    value: "is_paid"
                }
            ],
            items: [],
            loader: false,
            rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
            print_dialog: false,
            receipt_status_text: {
                0: "Hủy cọc",
                1: "Chưa nhận",
                2: "Đã nhận"
            }
        };
    },
    watch: {
        async print() {
            if (this.print_dialog) {
                this.print_dialog = false;
                await this.$nextTick();
            }
            this.print_dialog = true;
        },
        date_start: function(nv) {
            if (nv && this.date_end) this.getData();
        },
        date_end: function(nv) {
            if (nv && this.date_start) this.getData();
        },
        chosen_building: function(nv) {
            this.getData();
        },
        agent_id: function(nv) {
            this.getData();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData: async function() {
            this.items = [];
            this.loader = true;
            const params = {
                building: this.chosen_building,
                agent_id: this.agent_id,
                dateStart: this.date_start,
                dateEnd: this.date_end
            };
            const query = buildParamQuery(params);
            let data = await api.getCommission(query);
            if (data.status === 200) {
                this.items = data.data.map(receipt => {
                    const deposit = receipt.deposits[0];
                    receipt.is_check_in = deposit.is_check_in;
                    receipt.receipt_status = deposit.is_valid
                        ? receipt.is_check_in
                            ? 2//đã nhận phòng
                            : 1//Chưa nhận phòng
                        : 0;//Hủy cọc
                    receipt.status_text = this.receipt_status_text[receipt.receipt_status];
                    return receipt;
                });
            } else {
                swal.fire("Lỗi", data.message, "error");
            }
            this.loader = false;
        },

        toggleCommissionStatus: async function(commission) {
            this.$set(commission, "loading", true);
            const data = await api.updateReceipt(
                `/commissions/${commission._id}`,
                { is_paid: commission.is_paid }
            );
            commission.loading = false;
            if (data.status == 200) {
                // swal.fire('Thành công', 'Cập nhật giải thích thành công', 'success')
            } else {
                commission.is_paid = !commission.is_paid;
                // swal.fire('Thất bại', data.message, 'error')
            }
        }
    }
};
</script>

<style>
</style>